import { config } from 'app/config'

import { AvailableConnection } from '../types'

export const availableConnections: AvailableConnection[] = [
  {
    category: 'advertising',
    authConfig: {
      params: {
        client_id: config.amazonClientId,
        response_type: 'code',
        scope: ['advertising::campaign_management', 'advertising::audiences'].join(' '),
      },
      // Login with Amazon is region bound, we only support the european region
      url: 'https://eu.account.amazon.com/ap/oa',
    },
    config: {
      amcInstanceId: '',
    },
    name: 'amazon',
    readonly: false,
    // the amc instance is not configurable for now
    readonlyConfig: ['amcInstanceId'],
  },
  {
    category: 'advertising',
    authConfig: {
      params: {
        auth_type: 'rerequest',
        client_id: config.facebookClientId,
        display: 'popup',
        response_type: 'code',
        scope: ['ads_read', 'ads_management', 'email'].join(','),
      },
      url: 'https://www.facebook.com/v13.0/dialog/oauth',
    },
    config: {
      accounts: [],
      pixelId: '',
      adId: '',
    },
    name: 'facebook',
    readonly: false,
    readonlyConfig: ['pixelId'],
  },
  {
    category: 'warehouse',
    config: {
      project: '',
    },
    name: 'googleBigquery',
    readonly: true,
    readonlyConfig: [],
  },
  {
    category: 'advertising',
    authConfig: {
      params: {
        access_type: 'offline',
        client_id: config.analyticsClientId,
        include_granted_scopes: 'true',
        prompt: 'consent',
        response_type: 'code',
        state: 'access_token',
        scope: 'https://www.googleapis.com/auth/analytics.edit email profile',
      },
      url: 'https://accounts.google.com/o/oauth2/v2/auth',
    },
    config: {
      propertyId: '',
      measurementId: '',
      apiSecret: '',
    },
    name: 'googleAnalytics',
    readonly: false,
    readonlyConfig: ['propertyId'],
  },
  {
    category: 'website',
    config: {
      trackingUrl: '',
    },
    name: 'innkeepr',
    readonly: false,
    readonlyConfig: [],
  },
  {
    category: 'shopsystem',
    config: { shops: [] },
    name: 'shopify',
    readonly: false,
    readonlyConfig: [],
  },
  {
    category: 'shopsystem',
    config: {
      shopbaseUrl: '',
      apiKey: '',
      apiSecret: '',
    },
    name: 'woocommerce',
    readonly: false,
    readonlyConfig: [],
  },
  {
    category: 'advertising',
    authConfig: {
      params: {
        access_type: 'offline',
        client_id: config.adwordsClientId,
        include_granted_scopes: 'true',
        prompt: 'consent',
        response_type: 'code',
        state: 'access_token',
        scope:
          'https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/datamanager email profile',
      },
      url: 'https://accounts.google.com/o/oauth2/v2/auth',
    },
    config: {
      accounts: [],
      campaignId: '',
    },
    name: 'googleAdwords',
    readonly: false,
    readonlyConfig: [],
  },
  {
    category: 'advertising',
    authConfig: {
      params: {
        app_id: config.tiktokAppId,
      },
      url: `https://ads.tiktok.com/marketing_api/auth`,
    },
    config: {
      adAccountIds: '',
      adId: 'ttm',
    },
    name: 'tiktok',
    readonly: false,
    readonlyConfig: [],
  },
  {
    category: 'advertising',
    authConfig: {
      params: {
        response_type: 'code',
        client_id: config.criteoClientId,
        scope: 'campaign.read',
      },
      url: `https://consent.criteo.com/request`,
    },
    config: {
      advertisers: [],
      adSetId: '',
      gumCallerId: '',
    },
    name: 'criteo',
    readonly: false,
    readonlyConfig: [],
  },
  {
    category: 'advertising',
    authConfig: {
      params: {
        access_type: 'offline',
        client_id: config.dv360ClientId,
        include_granted_scopes: 'true',
        prompt: 'consent',
        response_type: 'code',
        state: 'access_token',
        scope: 'https://www.googleapis.com/auth/display-video email profile',
      },
      url: 'https://accounts.google.com/o/oauth2/v2/auth',
    },
    config: {
      advertisers: [],
      adGroupId: '',
    },
    name: 'dv360',
    readonly: false,
    readonlyConfig: [],
  },
]
